import React from "react";
import { useNavigate } from "react-router-dom";

// Renders text with @mentions turned into clickable profile links.
const RE = /(@[a-z0-9_]{2,20})/gi;

export function MentionText({ text, className }) {
  const navigate = useNavigate();
  if (!text) return null;
  const parts = text.split(RE);
  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (i % 2 === 1) {
          const uname = part.slice(1).toLowerCase();
          return (
            <button
              key={i}
              onClick={(e) => { e.stopPropagation(); navigate(`/u/${uname}`); }}
              className="font-semibold text-aura-cyan hover:underline"
            >
              {part}
            </button>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
}
